import { baseImages, baseTheme } from './theme';
import { customImages, customTheme } from './custom';

export const theme = { ...baseTheme, ...customTheme };
export const images = { ...baseImages, ...customImages };
